import React from "react";
import FileEditor from "./fileEditor";
import FileTreeVisualizer from "./fileTreeVisualizer";
import Loading from "./loading";
import useWindowWidth from "./useWindowWidth";

const ZipFileViewer = ({ name, updateCurrentFilename, updateCurrentFileData, currentFilename, currentFileData, isDarkTheme, updateIsDarkTheme, requestLifeCycle, blob, contents }) => {
    const width = useWindowWidth(1000);

    return (
        <>
            <div className={ `pdf-content-container  ${ width ? "small" : "" }` } style={{ minHeight: width ? "800px" : "" }}>
                <div className="editor-tree-container" style={{ flexDirection: width ? "column" : "", color: isDarkTheme? "var(--vs-icon)" : "var(--almost-black)", backgroundColor: isDarkTheme ? "var(--dark-background)" : "var(--gray-three)" }}>
                    {
                        requestLifeCycle

                        ?

                        <div className="loading-zip-container" style={{ color: "var(--almost-black)" }}>
                            <Loading />
                        </div>

                        :

                        <>
                            <FileTreeVisualizer contents={contents} updateCurrentFilename={updateCurrentFilename} updateCurrentFileData={updateCurrentFileData}/>
                            <FileEditor name={name} isDarkTheme={isDarkTheme} blob={blob} currentFileData={currentFileData} currentFilename={currentFilename} updateIsDarkTheme={updateIsDarkTheme}/>
                        </>

                    }
                </div>
            </div>
        </>
    );
}

export default ZipFileViewer;